import { forwardRef } from 'react';

import {
  ButtonProps,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

import { DialogCompositeMui as DialogComposite } from '../DialogCompositeMui';

const styles = createStyles({
  root: {},
});

export type CancelProps = Omit<ButtonProps, 'classes'> &
  WithStyles<typeof styles>;

const Cancel = forwardRef<HTMLButtonElement, CancelProps>((props, ref) => {
  const { classes, ...rest } = props;
  return (
    <DialogComposite.Actions.Cancel
      ref={ref}
      variant="text"
      className={classNames(classes.root, props.className)}
      {...rest}
    />
  );
});
Cancel.displayName = 'Cancel';

export default withStyles(styles)(Cancel);
